import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GrowlComponent } from './growl.component';
import { GrowlRoutingModule } from './growl-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {TableModule} from "../../component/ing/table/table";
import {GrowlModule} from "../../component/ing/growl/growl";
import {ButtonModule} from "../../component/ing/button/button";

@NgModule({
  imports: [
    CommonModule,
    GrowlRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    TableModule,
    GrowlModule,
    ButtonModule
  ],
  declarations: [GrowlComponent]
})
export class GrowlDemoModule { }


// WEBPACK FOOTER //
// ./src/app/view/growl/growlDemo.module.ts